import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import DateRange from "./main/DateRange";
import { Bar, Line } from "react-chartjs-2";
import { APIBaseURL, AccessToken } from "../Config";
import Swal from "sweetalert2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";
import axios from "axios";

import CHEUtilizationOnlyTable from "./CHEUtilizationOnlyTable";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export default function Reports() {
  const [type, setType] = useState("");
  const [SelectID, setSelectID] = useState(null);
  const [Data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [SelectedEquipment, setSelectedEquipment] = useState(null);
  const [ViewType, setViewType] = useState(null);

  const GetData = async (categoryId) => {
    setLoading(true);

    let url = `${APIBaseURL}/get/equipment/reports?category_id=${categoryId}`;
    if (start) url += `&start=${start}`;
    if (end) url += `&end=${end}`;
    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setReports(response.data.equipments || []); 
        setData(response.data);
      } else {
        setReports([]); 
        setData(response.data);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (Data?.tdy_trans) {
        const transactionsArray = Object.entries(Data?.tdy_trans)?.map(
          ([equipmentId, total]) => ({
            equipmentId,
            total: Number(total),
          })
        );

        // Prepare chart data
        const chartData = {
          labels: transactionsArray?.map((item) => item.equipmentId), // Use equipment ID as labels
          datasets: [
            {
              label: "Moves",
              data: transactionsArray?.map((item) => item.total),
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderColor: "#36a2eb",
              borderWidth: 1,
              fill: true,
              tension: 0.3,
            },
          ],
        };

        setTransactions(chartData);
      }
  }, [Data]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Today Data",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Time",
        },
      },
      y: {
        title: {
          display: true,
          text: "Sales",
        },
      },
    },
  };

  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(`${APIBaseURL}/equipment/category`, {
        headers: {
          "Content-Type": "application/json",
          access_token: `${AccessToken}`,
        },
      });

      if (response.data && response.data.status == "success") {
        setCategory(response.data.data);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error!",
        text: error.message || "Something went wrong while fetching data.",
      });
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  useEffect(() => {
    if (category) {
      setType(category[0]?.name);
      setSelectID(category[0]?.id);
    }
  }, [category]);


  const handleFormFilter = (e) => {
    e.preventDefault();
    let range = e.target.range.value;
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
  };

  useEffect(() => {
    if (SelectID) {
      GetData(SelectID);
    }
  }, [SelectID, start, end]);

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 display-1"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between mb-3">
                  <div className="col-md-12 my-2">
                    <div className="card my-3">
                      <div className="card-body">
                        <h3 className="text-primary">CHE Report</h3>
                        <form
                          className="needs-validation"
                          noValidate=""
                          onSubmit={handleFormFilter}
                        >
                          <div className="row">
                            <div className="col-md-4 col-sm-8">
                              <div className="form-floating form-floating-outline mb-6">
                                <DateRange />
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-4">
                              <button
                                type="submit"
                                className="btn btn-label-primary waves-effect waves-light me-1"
                              >
                                <i className="ri-arrow-right-line ri-20px" />
                              </button>
                              <button
                                type="submit"
                                className="btn btn-label-primary waves-effect waves-light me-1"
                              >
                                <i className="ri-restart-line ri-20px" />
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 my-2">
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          className="card mb-4"
                          style={{
                            backgroundColor: "rgba(40, 167, 69, 0.2)",
                          }}
                        >
                          <div className="card-body">
                            <div className="d-flex align-items-center flex-wrap gap-1">
                              <div className="avatar me-2">
                                <div className="avatar-initial rounded shadow-xs bg-success">
                                  <i className="ri-command-line ri-24px" />
                                </div>
                              </div>
                              <div className="card-info">
                                <p className="mb-0">Che Count</p>
                                <h5 className="mb-0">{reports.length}</h5>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="card mb-4"
                          style={{
                            backgroundColor: "rgba(23, 162, 184, 0.2)",
                          }}
                        >
                          <div className="card-body">
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              <div className="avatar me-2">
                                <div className="avatar-initial rounded shadow-xs bg-info">
                                  <i className="ri-verified-badge-line ri-24px" />
                                </div>
                              </div>
                              <div className="card-info">
                                <p className="mb-0">Total Moves</p>
                                <h5 className="mb-0">
                                  {reports.reduce(
                                    (total, report) =>
                                      total + Number(report.moves_count || 0),
                                    0
                                  )}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="card h-100 mb-5">
                          <div className="card-header">
                            <h4 className="text-primary text-center">
                              Today CHE Moves
                            </h4>
                          </div>
                          <div className="card-body">
                            {transactions && (
                              <Line
                                data={transactions}
                                options={options}
                                className="h-100"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 my-2">
                    <div className="card">
                      <div className="card-body px-2">
                        <div className="nav-align-top">
                          <ul className="nav nav-pills flex-md-row gap-2 gap-lg-0">
                            {category?.length > 0 ? (
                              category.map((category) => (
                                <li key={category.id} className="nav-item">
                                  <p
                                    className={`nav-link border ${
                                      type === category.slug
                                        ? "active"
                                        : "bg-label-primary"
                                    } waves-effect waves-light`}
                                    onClick={() => {
                                      setType(category.slug);
                                      setSelectID(category.id);
                                    }}
                                  >
                                    <span className="ms-0">
                                      {category.name}
                                    </span>
                                  </p>
                                </li>
                              ))
                            ) : (
                              <p>Loading...</p>
                            )}
                          </ul>
                        </div>

                        <div className="table-responsive text-nowrap">
                          <table className="table table-hover table-font table-striped">
                            <thead>
                              <tr className="table-primary">
                                <td>S.No.</td>
                                <td>Category</td>
                                <td>Equipment ID</td>
                                <td>Total Moves</td>
                                <td>Productive Moves</td>
                                <td>Unproductive Moves</td>
                              </tr>
                            </thead>
                            <tbody>
                              {reports.length > 0 ? (
                                reports.map((report, index) => (
                                  <tr
                                    key={index}
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#ModalViewMap"
                                    // onClick={() => setSelectedEquipment(report)}
                                  >
                                    <td>{index + 1}</td>
                                    <td>{type}</td>
                                    <td>{report.equipment_name}</td>
                                    <td>{report.moves_count}</td>
                                    <td>{report.productive_moves}  
                                      <a href="#"  
                                        data-bs-toggle="modal"
                                        data-bs-target="#ModalViewMap"
                                        onClick={() => {
                                          setSelectedEquipment(report);
                                          setViewType('productive');
                                        }}>
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                      </a>
                                    </td>
                                    <td>
                                      {report.unproductive_moves} 
                                      <a href="#"  
                                          data-bs-toggle="modal"
                                          data-bs-target="#ModalViewMap"
                                          onClick={() => {
                                            setSelectedEquipment(report);
                                            setViewType('unproductive');
                                          }}>
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                      </a>

                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6">Data Not Found...</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="ModalViewMap"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Transactions
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        // onClick={() => setModalData("")}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          {SelectedEquipment ? (
                            <CHEUtilizationOnlyTable
                            dd={{ equipment_name: SelectedEquipment.equipment_name, type: ViewType, start:start, end:end }}
                          />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        // onClick={() => setModalData("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
